import { lang } from '../../assets/lang'
import { delayHtml } from '../../data/modal/delayHtml'

export const facebookMediaHtml = 
'<div class="form-group text-left mt-2">' + 
  '<label for="fb-media-url">' + lang.facebook_media_html_label_media_url + '</label>' +
  '<input type="text" class="form-control" id="fb-media-url" placeholder="' + lang.facebook_media_html_placeholder_page_example + '" aria-describedby="fb-media-url-help">' +
'</div>' +

// Adds html for delay system
delayHtml